// React
import React, { Children } from "react";
// Components
import { Flex } from "components";
// Resources
import styles from "./Tiles.module.scss";

interface TilesProps {
  children: React.ReactElement[];
  size?: "small" | "large";
}

export const Tiles: React.FC<TilesProps> = ({ children, size = "small" }) => (
  <Flex container>
    {Children.map(children, (child, index) => (
      <Flex
        className={styles.tile}
        xs={12}
        m={6}
        l={size === "small" ? 3 : 4}
        xl={size === "small" ? 3 : 4}
        // We expect that each child will have a key as ESLint requires it when using .map()
        key={child.key || index}
        item
        itemGutter
      >
        {child}
      </Flex>
    ))}
  </Flex>
);
